// Chakra imports
import {
    Button,
    Flex,
    HStack,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import BelllTableRow from "../../../../components/Tables/BelllTableRow";
import React from "react";
import AddBellModal from "./AddBellModal";
import ContentLoader from "components/loader/ContentLoader";
import {getRemoteBellUrl} from "../../../../utils/BellSoundCache";

const BellTable = ({title, captions, bellList, handleBellUpload,fetchBellList,setIsEditSubmitted, isLoading = false}) => {
    const textColor = useColorModeValue("gray.700", "white");

    const {isOpen, onOpen, onClose} = useDisclosure(); // Modal state management

    return (
        <Card overflowX={{sm: "scroll", xl: "hidden"}}>
            <CardHeader p="16px 0 24px 0">
                <Flex justify="space-between" align="center" wrap="wrap" gap="12px">
                    {/* Title on the left */}
                    <Text fontSize="lg" color={textColor} fontWeight="semibold" flex="1" isTruncated>
                        {title}
                    </Text>

                    {/* Buttons on the right */}
                    <HStack spacing="3" wrap="wrap">
                        <Button colorScheme="blue" size="sm" onClick={onOpen}>
                            Add Bell
                        </Button>
                    </HStack>
                </Flex>
            </CardHeader>


            <CardBody>
                <Table variant='simple' color={textColor}>
                    <Thead>
                        <Tr my='.8rem' pl='0px' color='gray.400'>
                            {captions.map((caption, idx) => {
                                return (
                                    <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                                        {caption}
                                    </Th>
                                );
                            })}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {isLoading ? (
                            <Tr>
                                <Td colSpan={captions.length}>
                                    <ContentLoader minH='180px' label='Loading bells...'/>
                                </Td>
                            </Tr>
                        ) : bellList && bellList.length > 0 ? bellList.map((row) => {
                                return (
                                    <BelllTableRow
                                        key={`${row.email}-${row.name}`}
                                        id={row.id}
                                        name={row.name}
                                        hourTime={row.hourTime}
                                        bell={getRemoteBellUrl(row) || row.bell}
                                        bellName={row.bellName}
                                        bellMusicId={row.bellMusicId}
                                        queue={row.queue}
                                        status={row.status}
                                        email={row.email}
                                        subdomain={row.subdomain}
                                        domain={row.domain}
                                        date={row.date}
                                        playTime={row.playTime}
                                        fetchBellList={fetchBellList}
                                        setIsEditSubmitted={setIsEditSubmitted}
                                    />
                                );
                            }) :
                            <Tr>
                                <Td colSpan={captions.length} textAlign='center' py='36px' color='gray.400'>
                                    Bell Not Available
                                </Td>
                            </Tr>
                        }
                    </Tbody>
                </Table>
                {isOpen ?
                    <AddBellModal
                        isOpen={isOpen}
                        onClose={onClose}
                        handleBellUpload={handleBellUpload}
                    /> : ""
                }
            </CardBody>
        </Card>
    );
};

export default BellTable;
